<template>
  <div>
    <message-modal />
    <div>
      <main-header />
      <tabs
        ref="tabs"
        :options="{ useUrlFragment: false, defaultTabHash: 'general' }"
        class="spl-edit-tabs">
        <tab id="defaultFilter" name="Default Filter">
          <deadline-edit-default-filter />
        </tab>
      </tabs>
      <div class="spl-deadline-edit-action-bar">
        <form-button
          style="grid-column: 1"
          @onClick="handleCancel">
          Cancel
        </form-button>
        <div style="grid-column: 2" />
        <form-button
          style="grid-column: 3"
          data-cy="deadline-edit-next"
          @onClick="handleNext">
          Save
        </form-button>
      </div>
      <div v-if="isLoading" class="spl-load-img" />
    </div>
  </div>
</template>

<script>
import Helpers from '@/helpers'
import { mapState, mapMutations, mapActions } from 'vuex'
import MessageDialog from '@/components/shared/message-dialog'
import { create } from 'vue-modal-dialogs'
import { cloneDeep } from 'lodash'
import moment from 'moment'
import store from '@/store'
const messageDialog = create(MessageDialog, 'content')

export default {
  mixins: [Helpers],
  data () {
    return {
      isLoading: false,
      activeTab: 'defaultFilter',
      tabs: ['defaultFilter']
    }
  },
  computed: {
    ...mapState('deadline', ['loadedDeadline', 'currentEditDeadline'])
  },
  beforeRouteEnter (to, from, next) {
    // load the deadline before proceding when we enter an edit route
    if (to.name === 'deadline-edit') {
      store.dispatch('deadline/loadDeadline', to.params.id).then(() => {
        next()
      }).catch((error) => {
        next()
        window.bus.$emit('openErrorModal', error.ExceptionMessage)
      })
    } else {
      next()
    }
  },
  created () {
    if (this.$route.name === 'deadline-create') {
      // Set a default deadline when creating a new one
      this.setCurrentEditDeadline({
        Service_Level_ID: -1,
        Customer_ID: -1,
        Country_ID: -1,
        From_Postal_Code: '',
        To_Postal_Code: '',
        City: '',
        Open_Deadline_Day: '',
        Close_Deadline_Day: '',
        Open_Deadline_Time: '',
        Close_Deadline_Time: '',
        Valid_From: moment().toISOString(true),
        Valid_To: moment().toISOString(true),
        Weekend_Delivery: false
      })
    } else {
      this.setCurrentEditDeadline(cloneDeep(this.loadedDeadline))
    }
  },
  methods: {
    ...mapMutations('deadline', ['setCurrentEditDeadline']),
    ...mapActions('deadline', ['saveDeadline', 'loadDeadline']),

    // ************************ Show Login is set to true if teh user is not logged in or if the token has expired.
    validateAndSend () {
      // Validate the deadline before sending it
      var valid = true
      var validationMessage =''
      if (this.deadlineMissing()) {
        valid = false
        validationMessage = 'Please enter at least one of the values: Country, Customer or Service Level.'
      } else if (this.closeDeadlineMissing()) {
        valid = false
        validationMessage = 'Close Deadline must contain a value.'
      } else if (this.postalCodesMissing()) {
        valid = false
        validationMessage = 'Please enter values at one of Postal Code values.'
      } else if (this.dateFromAfterDateTo()) {
        valid = false
        validationMessage = "Please choose a valid date range where 'From' is before 'To'."
      } else if (this.dateFromValid()) {
        valid = false
        validationMessage = 'Valid From date cannot be in past.'
      }

      if (valid) {
        this.isLoading = true
        this.saveDeadline(this.currentEditDeadline).then((response) => {
          this.isLoading = false
          this.$router.back()
        }).catch((error) => {
          this.isLoading = false
          messageDialog('Something went wrong: ' + error.ExceptionMessage)
        })
      } else {
        messageDialog(validationMessage)
      }
    },
    deadlineMissing () {
      if (!this.currentEditDeadline.Customer_ID && !this.currentEditDeadline.Country_ID && !this.currentEditDeadline.Service_Level_ID) {
        return true
      }
    },
    closeDeadlineMissing () {
      if (this.currentEditDeadline.Close_Deadline_Time === '00:00' || this.currentEditDeadline.Close_Deadline_Time === '' || this.currentEditDeadline.Close_Deadline_Day === '') {
        return true
      }
      return false
    },
    postalCodesMissing () {
      if (this.currentEditDeadline.From_Postal_Code === '' && this.currentEditDeadline.To_Postal_Code === '') {
        return true
      }
      return false
    },
    dateFromValid () {
      var validfrom = this.formatDate(this.currentEditDeadline.Valid_From, false, 'YYYY-MM-DD')
      var todaysdate = this.formatDate(new Date(), false, 'YYYY-MM-DD')
      if (validfrom < todaysdate) {
        return true
      }
      return false
    },
    dateFromAfterDateTo () {
      if (this.currentEditDeadline.Valid_From > this.currentEditDeadline.Valid_To) {
        return true
      }
      return false
    },
    // *********************** Handle Actionbar *************************
    handleNext () {
      var deadline = cloneDeep(this.currentEditDeadline)
      deadline.Valid_From = deadline.Deadline_Filter.Valid_From
      deadline.Valid_To = deadline.Deadline_Filter.Valid_To
      if (deadline.Valid_To === null || deadline.Valid_To === '') {
        deadline.Valid_To = this.formatDate('9999-01-01', false, 'YYYY-MM-DD')
      }
      deadline.Country_ID = deadline.Deadline_Filter.Country_ID.value
      deadline.Customer_ID = deadline.Deadline_Filter.Customer_ID.value
      deadline.Service_Level_ID = deadline.Deadline_Filter.Service_Level_ID.value
      deadline.From_Postal_Code = deadline.Deadline_Filter.From_Postal_Code
      deadline.To_Postal_Code = deadline.Deadline_Filter.To_Postal_Code
      deadline.City = deadline.Deadline_Filter.City
      deadline.Weekend_Delivery = deadline.Deadline_Filter.Weekend_Delivery
      deadline.Open_Deadline_Day = deadline.Deadline_Filter.Open_Deadline_Day
      deadline.Close_Deadline_Day = deadline.Deadline_Filter.Close_Deadline_Day
      deadline.Open_Deadline_Time = deadline.Deadline_Filter.Open_Deadline_Time
      deadline.Close_Deadline_Time = deadline.Deadline_Filter.Close_Deadline_Time
      delete deadline.Deadline_Filter
      this.setCurrentEditDeadline(cloneDeep(deadline))
      this.validateAndSend()
    },
    handleCancel () {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss">
  @import '../variables.scss';
  .spl-edit-tabs {
    .tabs-component-panels {
      padding: 0 $mainPadding;
    }
    .tabs-component-tabs {
      background-color: $yellowButtonLabelHover;
      padding: 3px $mainPadding 13px $mainPadding;
      margin: 0;
      display: flex;
      .tabs-component-tab {
        color: white;
        padding-bottom: 5px;
        margin: 12px 10px 0 10px;
        list-style: none;
        font-size: 14px;
        &.is-active {
          color: #ebaa28;
          border-bottom: 2px solid #ebaa28;
        }
      }
    }
  }
</style>
